import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faThumbsUp } from '@fortawesome/free-regular-svg-icons';
import { faRocket, faShieldAlt, faUserFriends } from '@fortawesome/free-solid-svg-icons';
import Header from "./UI/Header";
const Section2 = (props) => {
    return (
        <Container fluid="md" className="section2">
            <div className="section__wrapper">
                <Row className="header__row">
                    <Header title="Why Choose Us"></Header>
                </Row>
                <Row className="content__row">
                    <Col md={6} lg={3}>
                        <div>

                            <div className="item_content">
                                <FontAwesomeIcon icon={faThumbsUp} />
                                <div className="item_introtext">
                                    <p>98% of<br />satisfied clients</p>	</div>

                            </div>
                            <div className="clearfix"></div>  </div>
                    </Col>
                    <Col md={6} lg={3}>
                        <article>

                            <div className="item_content">

                                <FontAwesomeIcon icon={faRocket} />
                                <div className="item_introtext">
                                    <p>QUICK ONBOARDING<br />PROCESS</p>	</div>

                            </div>
                            <div className="clearfix"></div>  </article>
                    </Col>
                    <Col md={6} lg={3}>
                        <article>

                            <div className="item_content">

                                <FontAwesomeIcon icon={faShieldAlt} />
                                <div className="item_introtext">
                                    <p>100%<br />guarantee</p></div>

                            </div>
                            <div className="clearfix"></div>  </article>
                    </Col>
                    <Col md={6} lg={3}>
                        <article>

                            <div className="item_content">

                                <FontAwesomeIcon icon={faUserFriends} />
                                <div className="item_introtext">
                                    <p>collaborative<br />team</p>	</div>

                            </div>
                            <div className="clearfix"></div>  </article>
                    </Col>
                </Row>
                </div>
        </Container>
    );
}

export default Section2;